import { render, staticRenderFns } from "./AyudaV2.html?vue&type=template&id=265e4a71&scoped=true&"
import script from "./AyudaV2.js?vue&type=script&lang=js&"
export * from "./AyudaV2.js?vue&type=script&lang=js&"
import style0 from "./AyudaV2.scss?vue&type=style&index=0&id=265e4a71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e4a71",
  null
  
)

export default component.exports